/* GFC Home Kit configurator (S5) — productos reales, solo fotos pasadas.
   Independiente del motor PDP (gfc-kit-configurator.js). */
(function () {
  'use strict';

  function initOne(cfg) {
    var section = document.querySelector('.gfc-kit[data-section-id="' + cfg.sectionId + '"]');
    if (!section || !cfg.equipacions || !cfg.equipacions.length) return;

    var els = {
      equipInputs: section.querySelectorAll('input[name="gfc-equip"]'),
      variantGrid: section.querySelector('#gfc-variant-grid'),
      sizesGrid: section.querySelector('#gfc-sizes-grid'),
      badges: section.querySelectorAll('input[name="gfc-badge"]'),
      tabs: section.querySelectorAll('.gfc-kit__tab'),
      panels: section.querySelectorAll('.gfc-kit__panel'),
      playerSelect: section.querySelector('#gfc-player'),
      customName: section.querySelector('#gfc-custom-name'),
      customNumber: section.querySelector('#gfc-custom-number'),
      price: section.querySelector('#gfc-price'),
      priceCompare: section.querySelector('#gfc-price-compare'),
      subtotal: section.querySelector('#gfc-subtotal'),
      atc: section.querySelector('#gfc-atc'),
      atcText: section.querySelector('#gfc-atc-text'),
      variantInput: section.querySelector('#gfc-variant-id'),
      propEquip: section.querySelector('#gfc-prop-equip'),
      propVariant: section.querySelector('#gfc-prop-variant'),
      propSize: section.querySelector('#gfc-prop-size'),
      propMode: section.querySelector('#gfc-prop-mode'),
      propName: section.querySelector('#gfc-prop-name'),
      propNumber: section.querySelector('#gfc-prop-number'),
      propBadge: section.querySelector('#gfc-prop-badge'),
      slides: section.querySelector('#gfc-slides'),
      thumbs: section.querySelector('#gfc-thumbs'),
      viewer: section.querySelector('.gfc-kit__viewer'),
      canvas: section.querySelector('#gfc-canvas'),
      canvasBase: section.querySelector('#gfc-canvas-base'),
      blurBack: section.querySelector('.gfc-kit__blur-back'),
      frontToggle: section.querySelector('[data-front-toggle]'),
      form: section.querySelector('#gfc-form')
    };

    var initBadge = section.querySelector('input[name="gfc-badge"]:checked');
    var state = {
      equip: cfg.equipacions[0],
      variant: null,
      size: null,
      mode: 'player',
      badgeKey: initBadge ? initBadge.value : 'none',
      badgePrice: initBadge ? (parseInt(initBadge.dataset.price || '0', 10) || 0) : 0
    };

    // Mateix format que el filtre `money` de Liquid (shop.money_format). Amb Intl
    // el preu inicial i el que escriu el JS sortien diferents (€80,00 vs 80,00 €).
    function money(cents) {
      var v = (cents || 0) / 100;
      var fmt = cfg.moneyFormat || '';
      if (fmt) {
        return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, tipus) {
          var dec = tipus.indexOf('no_decimals') !== -1 ? 0 : 2;
          var coma = tipus.indexOf('comma_separator') !== -1;
          var n = v.toFixed(dec);
          var parts = n.split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, coma ? '.' : ',');
          return dec ? parts[0] + (coma ? ',' : '.') + parts[1] : parts[0];
        });
      }
      try {
        return new Intl.NumberFormat(cfg.locale || 'es', {
          style: 'currency', currency: cfg.currency || 'EUR'
        }).format(v);
      } catch (e) { return v.toFixed(2) + ' ' + (cfg.currency || 'EUR'); }
    }

    // Arrel de l'idioma actiu ("/" en català, "/es/", "/en/"…). Totes les URL que es
    // construeixen des del JS han de penjar d'aquí: si no, en castellà es perd el "/es"
    // i el carretó i la caixa se'n van a català.
    function gfcRoot() {
      var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return r.charAt(r.length - 1) === '/' ? r : r + '/';
    }

    /* ---------- Fotos (solo las pasadas) ---------- */
    // Imagen según GÉNERO (variant) + PEGAT (laliga/sin) + cara. Fallback: foto de la equipación.
    function variantImages() {
      var v = state.variant, imgs = v && v.images;
      var laliga = state.badgeKey === 'laliga';
      function pick(side) {
        if (imgs) {
          var exact = imgs[side + '_' + (laliga ? 'laliga' : 'none')];
          if (exact) return exact;
          var other = imgs[side + '_' + (laliga ? 'none' : 'laliga')];
          if (other) return other;
        }
        return side === 'front' ? state.equip.front : state.equip.back;
      }
      return { front: pick('front') || '', back: pick('back') || '' };
    }
    function setPhotos() {
      var _im = variantImages();
      var back = _im.back || _im.front || '';
      var front = _im.front || _im.back || '';
      // slides front/back
      var slideImgs = els.slides.querySelectorAll('.gfc-kit__slide:not(.gfc-kit__slide--customize) img');
      if (slideImgs[0]) { slideImgs[0].src = front; slideImgs[0].srcset = ''; }
      if (slideImgs[1]) { slideImgs[1].src = back; slideImgs[1].srcset = ''; }
      // hide front slide/thumb if no real front
      var hasFront = !!_im.front;
      var fSlide = slideImgs[0] ? slideImgs[0].closest('.gfc-kit__slide') : null;
      if (fSlide) fSlide.style.display = hasFront ? '' : 'none';
      var thumbImgs = els.thumbs.querySelectorAll('.gfc-kit__thumb:not(.gfc-kit__thumb--customize) img');
      if (thumbImgs[0]) { thumbImgs[0].src = front; thumbImgs[0].srcset = ''; thumbImgs[0].closest('.gfc-kit__thumb').style.display = hasFront ? '' : 'none'; }
      if (thumbImgs[1]) { thumbImgs[1].src = back; thumbImgs[1].srcset = ''; }
      // customize: base = trasera, blur = frontal
      if (els.canvasBase) { els.canvasBase.src = back; els.canvasBase.srcset = ''; }
      if (els.blurBack) { els.blurBack.src = front; els.blurBack.srcset = ''; els.blurBack.style.display = hasFront ? '' : 'none'; }
      if (els.frontToggle) els.frontToggle.style.display = hasFront ? '' : 'none';
      if (!hasFront && els.viewer) els.viewer.classList.remove('is-front');
      if (els.viewer) els.viewer.classList.toggle('is-solo', !hasFront);
      if (els.canvasBase) {
        if (els.canvasBase.complete) redraw();
        else els.canvasBase.addEventListener('load', redraw, { once: true });
      }
    }

    /* ---------- VARIANT pills ---------- */
    function buildVariants() {
      els.variantGrid.innerHTML = '';
      state.equip.variants.forEach(function (v, i) {
        var lab = document.createElement('label');
        lab.className = 'gfc-kit__variant-opt';
        lab.innerHTML = '<input type="radio" name="gfc-variant" value="' + v.slot + '">' +
          '<span>' + v.label + '</span>';
        els.variantGrid.appendChild(lab);
        var inp = lab.querySelector('input');
        if (i === 0) { inp.checked = true; state.variant = v; }
        inp.addEventListener('change', function () {
          state.variant = v; buildSizes(); setPhotos(); recalc();
        });
      });
      state.variant = state.equip.variants[0] || null;
    }

    /* ---------- TALLA ---------- */
    function buildSizes() {
      els.sizesGrid.innerHTML = '';
      state.size = null;
      if (!state.variant) return;
      // Sense talla preseleccionada: el client tria (no marquem XS per defecte).
      state.variant.sizes.forEach(function (sz) {
        var lab = document.createElement('label');
        lab.className = 'gfc-kit__size';
        lab.innerHTML = '<input type="radio" name="gfc-size" value="' + (sz.value || '') + '"' +
          (sz.available ? '' : ' disabled') + '><span>' + (sz.value || '-') + '</span>';
        els.sizesGrid.appendChild(lab);
        var inp = lab.querySelector('input');
        inp.addEventListener('change', function () { state.size = sz; recalc(); });
      });
    }

    /* ---------- Precio + ATC ---------- */
    function basePrice() {
      if (state.size && typeof state.size.price === 'number') return state.size.price;
      return state.variant ? state.variant.price : 0;
    }
    function hasPersonalization() {
      if (state.mode === 'player') return !!playerName();
      if (state.mode === 'custom') {
        // Nom O número: amb qualsevol dels dos ja hi ha estampació (cobra).
        return !!((els.customName && els.customName.value) || (els.customNumber && els.customNumber.value));
      }
      return false;
    }
    function total() {
      var t = basePrice() + (state.badgePrice || 0);
      if (hasPersonalization() && !isFreePrinting()) t += (cfg.surcharge || 0);
      return t;
    }
    function recalc() {
      // El preu mostrat inclou estampació (+nom) i pegat, com a la PDP.
      if (els.price) els.price.textContent = money(total());
      if (els.subtotal) els.subtotal.textContent = money(total());
      // Preu barrat de l'equipació triada. Es compara amb el preu base (sense
      // estampació ni pegat): si no, desapareixeria en afegir el nom.
      if (els.priceCompare) {
        var cmp = 0;
        if (state.size && typeof state.size.compare === 'number') cmp = state.size.compare;
        else if (state.variant && typeof state.variant.compare === 'number') cmp = state.variant.compare;
        if (cmp > basePrice()) {
          els.priceCompare.textContent = money(cmp);
          els.priceCompare.hidden = false;
        } else {
          els.priceCompare.textContent = '';
          els.priceCompare.hidden = true;
        }
      }
      var ok = state.variant && state.size && state.size.available;
      var hasSizes = state.variant && state.variant.sizes && state.variant.sizes.some(function (sz) { return sz.available; });
      if (els.variantInput) els.variantInput.value = state.size ? state.size.id : '';
      if (els.propEquip) els.propEquip.value = state.equip.label;
      if (els.propVariant) els.propVariant.value = state.variant ? state.variant.label : '';
      if (els.propSize) els.propSize.value = state.size ? state.size.value : '';
      if (els.propMode) els.propMode.value = state.mode;
      if (els.propBadge) els.propBadge.value = state.badgeKey;
      if (els.propName) els.propName.value = state.mode === 'player' ? playerName() : (state.mode === 'custom' ? (els.customName.value || '') : '');
      if (els.propNumber) els.propNumber.value = state.mode === 'player' ? playerNumber() : (state.mode === 'custom' ? (els.customNumber.value || '') : '');
      if (els.atc) {
        els.atc.disabled = !ok;
        if (els.atcText) els.atcText.textContent = ok ? cfg.atcText : (hasSizes ? 'Tria una talla' : (cfg.soldOutText || 'Esgotat'));
      }
      redraw();
    }

    /* ---------- NOM I DORSAL ---------- */
    function selectedPlayerOpt() {
      if (!els.playerSelect) return null;
      return els.playerSelect.options[els.playerSelect.selectedIndex] || null;
    }
    function playerName() {
      var o = selectedPlayerOpt(); return o && o.value ? o.value : '';
    }
    function playerNumber() {
      var o = selectedPlayerOpt(); return o && o.dataset.number ? o.dataset.number : '';
    }
    // Estampació gratuïta per a un jugador concret (checkbox al bloc del jugador → data-free="true").
    function isFreePrinting() {
      if (state.mode !== 'player') return false;
      var o = selectedPlayerOpt();
      return !!(o && o.dataset && o.dataset.free === 'true');
    }
    function setTab(tab) {
      state.mode = tab;
      els.tabs.forEach(function (t) {
        var on = t.dataset.tab === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      els.panels.forEach(function (p) { p.hidden = p.dataset.panel !== tab; });
      recalc();
    }

    /* ---------- Canvas (nombre/dorsal sobre trasera) ---------- */
    function applyTransform(t) {
      var m = (els.canvas && els.canvas.dataset.textTransform) || 'uppercase';
      if (m === 'uppercase') return String(t || '').toUpperCase();
      if (m === 'lowercase') return String(t || '').toLowerCase();
      return String(t || '');
    }
    function pct(attr, fb) {
      var v = parseFloat(els.canvas && els.canvas.dataset[attr]);
      return isNaN(v) ? fb : v;
    }
    function drawText(ctx, text, x, y, size, fill, stroke, strokePct, font, weight) {
      ctx.save();
      ctx.font = (weight || '700') + ' ' + size + 'px ' + (font || 'Impact, sans-serif');
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.lineWidth = Math.max(2, size * (strokePct || 0.08));
      ctx.lineJoin = 'round';
      if (stroke) { ctx.strokeStyle = stroke; ctx.strokeText(text, x, y); }
      if (fill) { ctx.fillStyle = fill; ctx.fillText(text, x, y); }
      ctx.restore();
    }
    function drawTextArc(ctx, text, cx, cy, size, fill, stroke, strokePct, font, weight, arcDeg) {
      ctx.save();
      ctx.font = (weight || '700') + ' ' + size + 'px ' + (font || 'Impact, sans-serif');
      ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.lineWidth = Math.max(2, size * (strokePct || 0.08));
      ctx.lineJoin = 'round';

      var chars = String(text).split('');
      var widths = chars.map(function (c) { return ctx.measureText(c).width; });
      var totalW = widths.reduce(function (a, b) { return a + b; }, 0);
      var arcRad = (arcDeg || 0) * Math.PI / 180;
      if (Math.abs(arcRad) < 0.001) {
        if (stroke) { ctx.strokeStyle = stroke; ctx.strokeText(text, cx, cy); }
        if (fill) { ctx.fillStyle = fill; ctx.fillText(text, cx, cy); }
        ctx.restore(); return;
      }
      // Arc length = totalW = radius * |arcRad|
      var radius = totalW / Math.abs(arcRad);
      // sign>0 = "frown" (middle alto, ends abajo, típico dorsal). centro del círculo debajo de la línea base.
      var sign = arcRad >= 0 ? 1 : -1;

      // Mover el origen al centro del círculo (cx, cy + r*sign)
      ctx.translate(cx, cy + radius * sign);

      var angleStart = -Math.abs(arcRad) / 2;
      var accW = 0;
      for (var i = 0; i < chars.length; i++) {
        var w = widths[i];
        var charAngle = (angleStart + (accW + w / 2) / radius) * sign;
        accW += w;
        ctx.save();
        ctx.rotate(charAngle);
        ctx.translate(0, -radius * sign);   // sube al perímetro del círculo
        if (stroke) { ctx.strokeStyle = stroke; ctx.strokeText(chars[i], 0, 0); }
        if (fill) { ctx.fillStyle = fill; ctx.fillText(chars[i], 0, 0); }
        ctx.restore();
      }
      ctx.restore();
    }
    function redraw() {
      if (!els.canvas || !els.canvasBase) return;
      var img = els.canvasBase;
      var rect = img.getBoundingClientRect();
      if (!rect.width) return;
      var dpr = window.devicePixelRatio || 1;
      els.canvas.width = rect.width * dpr;
      els.canvas.height = rect.height * dpr;
      els.canvas.style.width = rect.width + 'px';
      els.canvas.style.height = rect.height + 'px';
      var ctx = els.canvas.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.clearRect(0, 0, rect.width, rect.height);
      if (state.mode === 'none') return;
      var nm = applyTransform(state.mode === 'custom' ? (els.customName && els.customName.value) : playerName());
      var nu = String(state.mode === 'custom' ? (els.customNumber && els.customNumber.value || '') : playerNumber());
      var d = els.canvas.dataset;
      // Badge override (LaLiga → font + arc + colores)
      var checked = section.querySelector('input[name="gfc-badge"]:checked');
      var badgeFont = checked && checked.dataset.fontFamily;
      var badgeArc = checked && Number(checked.dataset.arcDeg || 0);
      var font = badgeFont || d.defaultFont || 'Impact, Arial Narrow, sans-serif';
      var arc = badgeArc || (parseFloat(d.nameArcDeg) || 0);
      // Overrides tamaño/borde/grosor/posición: prioridad EQUIPACIÓN → PEGAT → global
      // ("la equipación manda"; 0/vacío = hereda del siguiente nivel).
      var equip = section.querySelector('input[name="gfc-equip"]:checked');
      var _eNameSize = equip && parseFloat(equip.dataset.nameSizePct);
      var _bNameSize = checked && parseFloat(checked.dataset.nameSizePct);
      var _eNumSize = equip && parseFloat(equip.dataset.numberSizePct);
      var _bNumSize = checked && parseFloat(checked.dataset.numberSizePct);
      var _eStroke = equip && parseFloat(equip.dataset.strokeWidthPct);
      var _bStroke = checked && parseFloat(checked.dataset.strokeWidthPct);
      var nameSizePctV = (_eNameSize > 0) ? _eNameSize : (_bNameSize > 0) ? _bNameSize : pct('nameSizePct', 7);
      var numSizePctV = (_eNumSize > 0) ? _eNumSize : (_bNumSize > 0) ? _bNumSize : pct('numberSizePct', 18);
      var strokePctV = (_eStroke > 0) ? _eStroke : (_bStroke > 0) ? _bStroke : pct('strokeWidthPct', 8);
      var nameWeightV = (equip && equip.dataset.nameWeight) || (checked && checked.dataset.nameWeight) || d.nameWeight;
      var numWeightV = (equip && equip.dataset.numberWeight) || (checked && checked.dataset.numberWeight) || d.numberWeight;
      var _posSrc = (equip && equip.dataset.posOverride === 'true') ? equip
                  : (checked && checked.dataset.posOverride === 'true') ? checked : null;
      var nameXPctV = _posSrc ? parseFloat(_posSrc.dataset.nameXPct) : pct('nameXPct', 50);
      var nameYPctV = _posSrc ? parseFloat(_posSrc.dataset.nameYPct) : pct('nameYPct', 32);
      var numXPctV = _posSrc ? parseFloat(_posSrc.dataset.numberXPct) : pct('numberXPct', 50);
      var numYPctV = _posSrc ? parseFloat(_posSrc.dataset.numberYPct) : pct('numberYPct', 52);
      // Si la fuente aún no está cargada, dibuja fallback ahora y re-dibuja al cargar
      var fam = String(font).split(',')[0].replace(/['"]/g, '').trim();
      if (fam && document.fonts && document.fonts.check && !document.fonts.check('24px "' + fam + '"')) {
        if (!redraw._pending) { redraw._pending = {}; }
        if (!redraw._pending[fam]) {
          redraw._pending[fam] = true;
          document.fonts.load('400 100px "' + fam + '"').then(function () { redraw._pending[fam] = false; redraw(); })
            .catch(function () { redraw._pending[fam] = false; });
        }
      }
      // Color del dorsal: la EQUIPACIÓN manda siempre (con o sin pegat). Si la
      // equipación no define color, se usa el del parche y, por último, el global.
      // "Borde AMB pegat" (name_stroke_badge): borde propio de la equipación SOLO
      // cuando hay pegat seleccionado (ej. Segona 26/27: blanc amb LaLiga, sense sense pegat).
      var equip = section.querySelector('input[name="gfc-equip"]:checked');
      var hasBadge = !!(checked && checked.value && checked.value !== 'none');
      var nameColor   = (equip && equip.dataset.nameColor)   || (checked && checked.dataset.nameColor)   || d.nameColor;
      var nameStroke  = (hasBadge && equip && equip.dataset.nameStrokeBadge)
                      || (equip && equip.dataset.nameStroke)  || (checked && checked.dataset.nameStroke)  || d.nameStroke;
      var numberColor = (equip && equip.dataset.numberColor) || (checked && checked.dataset.numberColor) || d.numberColor;
      var numberStroke= (hasBadge && equip && equip.dataset.numberStrokeBadge)
                      || (equip && equip.dataset.numberStroke)|| (checked && checked.dataset.numberStroke)|| d.numberStroke;

      if (nm) {
        var nameX = rect.width * nameXPctV / 100;
        var nameY = rect.height * nameYPctV / 100;
        var nameSize = rect.width * nameSizePctV / 100;
        if (Math.abs(arc) > 0.5) {
          drawTextArc(ctx, nm, nameX, nameY, nameSize, nameColor, nameStroke, strokePctV / 100, font, nameWeightV, arc);
        } else {
          drawText(ctx, nm, nameX, nameY, nameSize, nameColor, nameStroke, strokePctV / 100, font, nameWeightV);
        }
      }
      if (nu) drawText(ctx, nu, rect.width * numXPctV / 100, rect.height * numYPctV / 100,
        rect.width * numSizePctV / 100, numberColor, numberStroke, strokePctV / 100, font, numWeightV);
    }

    /* ---------- Eventos ---------- */
    // Filtre de jugadors per equipació: cada equipació pot definir una clau
    // (players_filter, ex. "porter") i només mostra els jugadors amb la mateixa
    // equip_key. Sense clau → jugadors sense clau (plantilla normal).
    function filterPlayers() {
      if (!els.playerSelect) return;
      // iOS/Android ignoren hidden/disabled al picker natiu del <select> →
      // cal treure i tornar a posar les <option> físicament.
      if (!els.playerSelect._all) {
        els.playerSelect._all = Array.prototype.slice.call(els.playerSelect.options)
          .filter(function (o) { return o.value; }); // snapshot sense el placeholder
      }
      var eq = section.querySelector('input[name="gfc-equip"]:checked');
      var want = (eq && eq.dataset.playersFilter) || '';
      var current = els.playerSelect.value;
      els.playerSelect._all.forEach(function (o) { if (o.parentNode) o.parentNode.removeChild(o); });
      var stillThere = false;
      els.playerSelect._all.forEach(function (o) {
        if ((o.dataset.equipKey || '') === want) {
          els.playerSelect.appendChild(o);
          if (o.value === current) stillThere = true;
        }
      });
      if (!stillThere) {
        els.playerSelect.selectedIndex = 0;
        if (els.propName) els.propName.value = '';
        if (els.propNumber) els.propNumber.value = '';
      }
    }
    els.equipInputs.forEach(function (inp) {
      inp.addEventListener('change', function () {
        var e = cfg.equipacions.filter(function (x) { return x.key === inp.value; })[0];
        if (!e) return;
        state.equip = e;
        filterPlayers();
        buildVariants(); buildSizes(); setPhotos(); recalc();
        redraw(); // recolorear el dorsal con el color propio de la equipación
      });
    });
    filterPlayers();
    els.badges.forEach(function (b) {
      b.addEventListener('change', function () {
        state.badgeKey = b.value;
        state.badgePrice = parseInt(b.dataset.price || '0', 10) || 0;
        setPhotos();
        recalc();
      });
    });
    els.tabs.forEach(function (t) {
      t.addEventListener('click', function () { setTab(t.dataset.tab); });
    });
    if (window.ResizeObserver && els.canvasBase) {
      var ro = new ResizeObserver(function () { redraw(); });
      ro.observe(els.canvasBase);
    }
    if (els.viewer) els.viewer.addEventListener('transitionend', redraw);
    if (els.playerSelect) els.playerSelect.addEventListener('change', recalc);
    // Filtro nombre: solo letras (incl. acentos), puntos, guiones y espacios. Máx 12.
    if (els.customName) {
      els.customName.setAttribute('maxlength', '12');
      els.customName.addEventListener('input', function () {
        var clean = this.value
          .replace(/[^A-Za-zÁÉÍÓÚÀÈÌÒÙÄËÏÖÜÑÇáéíóúàèìòùäëïöüñç.\-\s]/g, '')
          .slice(0, 12);
        if (clean !== this.value) this.value = clean;
        recalc();
      });
    }
    if (els.customNumber) els.customNumber.addEventListener('input', recalc);
    window.addEventListener('resize', redraw);

    function isBlocked(name) {
      if (!cfg.blockedWords) return false;
      var norm = String(name || '').toLowerCase()
        .normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
      if (!norm) return false;
      return cfg.blockedWords.split(',').map(function (w) {
        return w.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
      }).filter(Boolean).some(function (w) { return norm.indexOf(w) !== -1; });
    }

    if (els.form) {
      els.form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!state.size || !state.size.available) return;
        if (state.mode === 'custom' && els.customName && isBlocked(els.customName.value)) {
          els.customName.setCustomValidity('Aquest nom no està permès.');
          els.customName.reportValidity();
          els.customName.classList.add('is-error');
          return;
        }
        if (els.customName) { els.customName.setCustomValidity(''); els.customName.classList.remove('is-error'); }
        els.atc.classList.add('is-loading');
        // Bundle: camiseta + línies fee enllaçades (estampació, pegat) que SÍ sumen al total.
        var bundleId = 'gfc-' + Date.now() + '-' + Math.floor(Math.random() * 1e6);
        var personalized = hasPersonalization();
        var items = [{
          id: state.size.id,
          quantity: 1,
          // Prefijo "_" = property oculta al cliente (carrito/checkout/emails), visible en admin para producción.
          properties: {
            '_Equipació': state.equip.label,
            '_Variant': state.variant ? state.variant.label : '',
            '_Talla': state.size.value,
            '_Pegat': state.badgeKey === 'none' ? 'Sense pegat' : state.badgeKey,
            '_Mode': state.mode,
            '_Nom': els.propName ? els.propName.value : '',
            '_Dorsal': els.propNumber ? els.propNumber.value : '',
            '_bundle': bundleId
          }
        }];
        if (personalized && !isFreePrinting() && cfg.nameFeeVariant) {
          items.push({ id: cfg.nameFeeVariant, quantity: 1, properties: { '_bundle': bundleId, '_fee': 'estampacio' } });
        }
        var badgeFee = (state.badgeKey && state.badgeKey !== 'none' && cfg.badgeFees) ? cfg.badgeFees[state.badgeKey] : null;
        if (badgeFee) {
          items.push({ id: badgeFee, quantity: 1, properties: { '_bundle': bundleId, '_fee': 'pegat' } });
        }
        fetch(gfcRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble,header' })
        }).then(function (r) { return r.json(); }).then(function (data) {
          els.atc.classList.remove('is-loading');
          els.atc.classList.add('is-added');
          // Personalización también en NOTAS del pedido. La nota se RECONSTRUYE entera a
          // partir del carrito actual (no se acumula: si no, quedan configs de sesiones
          // abandonadas o de artículos eliminados — ver pedido #2102 con 4 configs).
          try {
            fetch(gfcRoot() + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
              var blocks = [];
              (((c && c.items) || [])).forEach(function (it) {
                var p = it.properties || {};
                if (!p._bundle || p._fee) return; // solo camisetas del configurador, no recargos
                var nl = [];
                Object.keys(p).forEach(function (k) {
                  if (p[k] !== '' && p[k] != null) nl.push(k + ': ' + p[k]);
                });
                if (nl.length) blocks.push(nl.join('\n'));
              });
              fetch(gfcRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: blocks.join('\n\n') }) });
            }).catch(function () {});
          } catch (e) {}
          // Detail con shape Horizon (data.sections para component-cart-items, resource para cart-drawer)
          var detail = { resource: data, data: { sections: data.sections } };
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
          document.dispatchEvent(new CustomEvent('cart:add', { bubbles: true, detail: detail }));
          var drawer = document.querySelector('cart-drawer-component, #cart-drawer, [data-cart-drawer]');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          else if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
          else { window.location.href = gfcRoot() + 'cart'; }
        }).catch(function () {
          els.atc.classList.remove('is-loading');
          window.location.href = gfcRoot() + 'cart';
        });
      });
    }

    /* Preload fuentes de badges (canvas no fuerza fetch como DOM) */
    if (document.fonts && document.fonts.load) {
      var fontFamilies = new Set();
      section.querySelectorAll('input[name="gfc-badge"]').forEach(function (b) {
        var f = b.dataset.fontFamily;
        if (f && f.trim()) fontFamilies.add(f.trim().replace(/^['"]|['"]$/g, ''));
      });
      var defF = els.canvas && els.canvas.dataset.defaultFont;
      if (defF) defF.split(',').forEach(function (f) {
        f = f.trim().replace(/^['"]|['"]$/g, ''); if (f) fontFamilies.add(f);
      });
      Promise.all([...fontFamilies].map(function (f) {
        return document.fonts.load('700 100px "' + f + '"').catch(function(){});
      })).then(redraw);
      document.fonts.ready.then(redraw);
    }

    /* ---------- Init ---------- */
    buildVariants();
    buildSizes();
    setPhotos();
    // Por defecto se ve la cara TRASERA; el botón gfc-kit__front-toggle muestra la frontal (si la hay).
    if (els.viewer) els.viewer.classList.remove('is-front');
    setTab(els.playerSelect && els.playerSelect.options.length > 1 ? 'player' : 'custom');
    recalc();
  }

  /* Toggle frontal/trasera por delegación — independiente del init */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-front-toggle]');
    if (!btn) return;
    e.preventDefault();
    var viewer = btn.closest('.gfc-kit__viewer');
    if (viewer) viewer.classList.toggle('is-front');
  });

  function init() {
    var map = window.gfcHomeKit || {};
    Object.keys(map).forEach(function (k) { initOne(map[k]); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
